var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLineGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 67,
    viewBox: "0 0 64 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    width: 54,
    height: 54,
    rx: 10,
    fill: "#148F2D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 0.5,
    width: 53,
    height: 53,
    rx: 9.5,
    stroke: "white",
    strokeOpacity: 0.05
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.9398 24.1154C42.0541 24.1114 42.1681 24.1306 42.2749 24.1716C42.3817 24.2127 42.4792 24.2748 42.5615 24.3543C42.6438 24.4338 42.7092 24.529 42.7539 24.6344C42.7986 24.7397 42.8217 24.853 42.8217 24.9674C42.8217 25.0818 42.7986 25.1951 42.7539 25.3004C42.7092 25.4058 42.6438 25.501 42.5615 25.5805C42.4792 25.66 42.3817 25.7222 42.2749 25.7632C42.1681 25.8042 42.0541 25.8234 41.9398 25.8194H39.5715V27.3382H41.9398C42.0548 27.3326 42.1698 27.3504 42.2778 27.3905C42.3857 27.4307 42.4844 27.4923 42.5678 27.5718C42.6512 27.6512 42.7176 27.7468 42.763 27.8526C42.8083 27.9585 42.8317 28.0725 42.8317 28.1877C42.8317 28.3028 42.8083 28.4168 42.763 28.5227C42.7176 28.6286 42.6512 28.7241 42.5678 28.8036C42.4844 28.883 42.3857 28.9447 42.2778 28.9848C42.1698 29.025 42.0548 29.0428 41.9398 29.0371H38.723C38.4982 29.0363 38.2828 28.9465 38.124 28.7873C37.9652 28.6281 37.8759 28.4125 37.8756 28.1877V21.7482C37.8756 21.2794 38.2553 20.8946 38.723 20.8946H41.9458C42.1645 20.9059 42.3704 21.0009 42.5209 21.1599C42.6714 21.3188 42.755 21.5296 42.7544 21.7486C42.7537 21.9675 42.6689 22.1778 42.5174 22.3358C42.3659 22.4939 42.1595 22.5877 41.9408 22.5977H39.5725V24.1164L41.9398 24.1154ZM36.7416 28.1867C36.7397 28.4122 36.6489 28.6278 36.4889 28.7867C36.3288 28.9456 36.1125 29.0349 35.887 29.0351C35.7535 29.0364 35.6215 29.0066 35.5015 28.9481C35.3815 28.8896 35.2767 28.804 35.1955 28.698L31.8998 24.2156V28.1856C31.8998 28.4109 31.8103 28.627 31.651 28.7863C31.4917 28.9456 31.2756 29.0351 31.0503 29.0351C30.825 29.0351 30.609 28.9456 30.4496 28.7863C30.2903 28.627 30.2008 28.4109 30.2008 28.1856V21.7461C30.2008 21.3827 30.4388 21.0566 30.781 20.9402C30.8655 20.9103 30.9546 20.8956 31.0442 20.8967C31.3075 20.8967 31.5505 21.0394 31.7135 21.2399L35.0355 25.7324V21.7461C35.0355 21.2774 35.4152 20.8926 35.885 20.8926C36.3548 20.8926 36.7396 21.2774 36.7396 21.7461L36.7416 28.1867ZM28.9899 28.1867C28.9888 28.4125 28.8983 28.6287 28.7381 28.7879C28.5779 28.9472 28.3612 29.0364 28.1353 29.0361C27.9112 29.0343 27.6968 28.944 27.5389 28.7849C27.3809 28.6258 27.2922 28.4108 27.2919 28.1867V21.7472C27.2919 21.2784 27.6716 20.8936 28.1414 20.8936C28.6102 20.8936 28.9909 21.2784 28.9909 21.7472L28.9899 28.1867ZM25.6618 29.0361H22.439C22.2134 29.0356 21.9971 28.9461 21.8371 28.7871C21.6771 28.628 21.5863 28.4122 21.5845 28.1867V21.7472C21.5845 21.2784 21.9692 20.8936 22.439 20.8936C22.9088 20.8936 23.2885 21.2784 23.2885 21.7472V27.3372H25.6618C25.8871 27.3372 26.1032 27.4267 26.2625 27.586C26.4218 27.7453 26.5113 27.9614 26.5113 28.1867C26.5113 28.4119 26.4218 28.628 26.2625 28.7873C26.1032 28.9466 25.8871 29.0361 25.6618 29.0361ZM48.2 24.7209C48.2 17.4704 40.9273 11.5695 32 11.5695C23.0728 11.5695 15.8 17.4704 15.8 24.7209C15.8 31.2181 21.5642 36.6603 29.3473 37.694C29.8748 37.8044 30.5917 38.0423 30.7769 38.4909C30.94 38.8959 30.8822 39.5236 30.8296 39.9519L30.6079 41.3279C30.5441 41.7339 30.2808 42.9266 32.0213 42.1986C33.7669 41.4706 41.3606 36.6937 44.7616 32.7794C47.0873 30.2329 48.2 27.6166 48.2 24.7209Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 64,
    height: 67,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.08 0 0 0 0 0.08 0 0 0 0 0.08 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.4,
    height: 32.4,
    fill: "white",
    transform: "translate(15.8 10.8)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineGreen);
export default __webpack_public_path__ + "static/media/line-green.8d0bc21085e14a6870f49e9cb1cb0ebc.svg";
export { ForwardRef as ReactComponent };